<template>
    <div>
        <div v-if="isLoading" class="loader-holder">
            <Loader></Loader>
        </div>

        <div v-else-if="hasError" class="error-holder container text-center">
            <i class="fa fa-exclamation-triangle"></i>
            <p v-if="errorMessage.length">{{errorMessage}}</p>
            <p v-else>Oeps ... er is iets misgegaan</p>
        </div>

        <form v-else v-on:submit.prevent="onSubmit">
            <div class="container">
                <div class="wrap-block13">
                    <div class="row mb-3" v-if="stepDescription">
                        <div class="col-md-12 offset-lg-2 col-lg-8 text-center">
                            <h2>{{stepDescription.title}}</h2>
                            <p>{{stepDescription.description}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class=" col-md-12 offset-lg-2 col-lg-8">
                            <Field v-for="question in questions"
                                   :key="question.id"
                                   :question="question"
                                   :answer="getAnswer(question)"></Field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12 buttons-holder text-center" >
                        <button v-if="currentStep !== 1"
                                type="button"
                                v-on:click="onPreviousStepClick()"
                                class="btn btn-warning">Vorige
                        </button>
                        <button type="submit" class="btn btn-warning">{{nextButtonText}} </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <steps :totalSteps="totalSteps" :currentStep="currentStep"></steps>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import store from '../store'
  import Field from './partials/questions/Field'
  import Steps from './partials/questions/Steps'
  import Loader from './partials/Loader'
  import UserAgent from '../services/UserAgent'
  import _ from 'underscore'

  export default {
    name: 'question_list',
    components: {
      Field,
      Steps,
      Loader,
    },
    data () {
      return {
        answers: []
      }
    },
    methods: {
      getAnswer (question) {
        let answer = _.find(this.answers, (answer) => +answer.question_id === +question.id)

        if (typeof answer === 'undefined') {
          answer = {question_id: +question.id, value: ''}
          this.answers.push(answer)
        }

        return answer
      },
      onSubmit () {
        window.scrollTo(0, 0)
        store.dispatch('question/nextStep', {answers: this.answers})
      },
      onPreviousStepClick () {
        window.scrollTo(0, 0)
        store.commit('question/previousStep')
      },
    },
    mounted: function () {
      if (+this.intakeId !== +this.$route.params.intake_id) {
        store.commit('question/clearState')
      }

      // validate credentials
      store.commit('question/setCredentials', {intakeId: this.$route.params.intake_id, token: this.$route.params.token})
      store.dispatch('question/auth')

      if (UserAgent.isMobile()) {
        store.commit('question/isMobile')
      } else {
        store.commit('question/isDesktop')
      }
    },
    watch: {
      isComplete (isComplete) {
        if (isComplete) {
          this.$router.push('/vragenlijst-afgerond')
        }
      },
      questions (questions) {
        this.answers = []
        _.each(questions, (question) => {
          let answer = this.$store.getters['question/getAnswerByQuestionId'](question.id)
          if (typeof answer !== 'undefined') {
            this.answers.push(answer)
          } else {
            this.answers.push({question_id: +question.id, value: ''})
          }
        })
      }
    },
    computed: {
      ...mapGetters({
        questions: 'question/getCurrentQuestions',
        currentStep: 'question/getCurrentStep',
        totalSteps: 'question/getTotalSteps',
        hasError: 'question/hasError',
        isComplete: 'question/isComplete',
        isLoading: 'question/isLoading',
        errorMessage: 'question/getErrorMessage',
        stepDescription: 'question/getCurrentStepDescription',
        intakeId: 'question/getIntakeId',
      }),
       nextButtonText () {
        return +this.currentStep === +this.totalSteps ? 'Afronden' : 'Volgende'
      },
    },
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    .btn-warning {
        margin-top: 30px;
        width: auto;
    }

    .error-holder {
        margin-top: 50px;
        i {
            color: #fff;
            font-size: 55px;
            margin-bottom: 10px;
        }
    }

    .loader-holder {
        margin-top: 50px;
    }

    .btn.btn-warning:nth-child(2) {
        margin-left: 10px;
    }

    .wrap-block12 {
        margin-top: 60px;
    }

    .wrap-block13 {
        margin-top: 40px;
        text-align: left;
        color: white;

        .senioriteit-wrap3 {
            position: relative;

            .drop3 {
                position: absolute;
                z-index: 1;
                right: 61px;
                width: 10%;
            }
        }

        .txt-area {
            min-height: 100px;
        }

        .text-area .txt-area .form-control {
            color: white;
        }

        .form-control {
            display: block;
            width: 80%;
            height: calc(2.25rem + 2px);
            padding: 0.375rem 0.75rem;
            font-size: 1rem;
            line-height: 1.5;
            color: white;
            background-color: #89b7d2;
            background-clip: padding-box;
            margin: 12px;
            border: none;
            border-radius: 0.25rem;

            &::placeholder {
                color: white;
            }

            .col-form-label {
                margin-left: 40px;
            }
        }
    }

    .btn-warning {
        margin-top: 30px;
        width: 30%;
        display:inline-block;
        text-overflow: ellipsis;
        overflow:hidden;
        word-wrap: break-word;
    }
    .buttons-holder{
        justify-content:center;
    }
    @media (max-width: 540px) {
        .btn-warning {
            width: 44%;
            margin: 0 2%;
            font-size: 12px;
        }
    }

    @media (min-width: 541px) {
        .btn-warning {
            width: 30%;
        }
    }
</style>



